import { useMemo } from "react"

import type { CalculatedKPIs } from "../types/use-case.types"

import { calculateKPIs } from "../utils/financial-calculations"

export function useUseCaseCalculations(params: {
  timeSavedHours: string
  timeSavedUnit: string
  users: string
  salary: string
  directYear: string
  investment: string
  opCost: string
  opCostUnit: string
}): CalculatedKPIs {
  return useMemo(
    () =>
      calculateKPIs({
        timeSavedHours: parseFloat(params.timeSavedHours) || 0,
        timeSavedUnit: params.timeSavedUnit as "week" | "month" | "once",
        users: parseInt(params.users) || 0,
        salary: parseFloat(params.salary) || 70000,
        directYear: parseFloat(params.directYear) || 0,
        investment: parseFloat(params.investment) || 0,
        opCost: parseFloat(params.opCost) || 0,
        opCostUnit: params.opCostUnit as "monthly" | "yearly",
      }),
    [
      params.timeSavedHours,
      params.timeSavedUnit,
      params.users,
      params.salary,
      params.directYear,
      params.investment,
      params.opCost,
      params.opCostUnit,
    ]
  )
}
